export const STYLES_REGULAR_24PX_32PX = {
  fontFamily: 'Noto Sans',
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '32px',
  letterSpacing: '-0.3px'
} as const;

export const STYLES_REGULAR_40PX_52PX = {
  fontFamily: 'Noto Sans',
  fontSize: '40px',
  fontWeight: 400,
  lineHeight: '52px',
  letterSpacing: '-0.7px'
} as const;

export const STYLES_REGULAR_16PX_24PX = {
  fontFamily: 'Noto Sans',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '-0.12px'
} as const;

export const STYLES_REGULAR_14PX_20PX = {
  fontFamily: 'Noto Sans',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  letterSpacing: '-0.1px'
} as const;

/** Local style applied to the "expand/collapse" label in the left sidebar or at the top of collapsible components on the map. */
export const STYLES_REGULAR_8PX_12PX = {
  fontFamily: 'Noto Sans',
  fontSize: '8px',
  fontWeight: 400,
  lineHeight: '12px',
  letterSpacing: '-0.06px'
} as const;

export const STYLES_REGULAR_12PX_16PX = {
  fontFamily: 'Noto Sans',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  letterSpacing: '-0.09px'
} as const;

export const STYLES_REGULAR_10PX_14PX = {
  fontFamily: 'Noto Sans',
  fontSize: '10px',
  fontWeight: 400,
  lineHeight: '14px',
  letterSpacing: '-0.07px'
} as const;

export const STYLES_REGULAR_20PX_28PX = {
  fontFamily: 'Noto Sans',
  fontSize: '20px',
  fontWeight: 400,
  lineHeight: '28px',
  letterSpacing: '-0.15px'
} as const;

export const STYLES_REGULAR_32PX_40PX = {
  fontFamily: 'Noto Sans',
  fontSize: '32px',
  fontWeight: 400,
  lineHeight: '40px',
  letterSpacing: '-0.4px'
} as const;

export const STYLES_SEMIBOLD_20PX_28PX = {
  fontFamily: 'Noto Sans',
  fontSize: '20px',
  fontWeight: 600,
  lineHeight: '28px',
  letterSpacing: '-0.15px'
} as const;

export const STYLES_SEMIBOLD_40PX_52PX = {
  fontFamily: 'Noto Sans',
  fontSize: '40px',
  fontWeight: 600,
  lineHeight: '52px',
  letterSpacing: '-0.7px'
} as const;

export const STYLES_SEMIBOLD_56PX_64PX = {
  fontFamily: 'Noto Sans',
  fontSize: '56px',
  fontWeight: 600,
  lineHeight: '64px',
  letterSpacing: '-0.98px'
} as const;

export const STYLES_SEMIBOLD_32PX_40PX = {
  fontFamily: 'Noto Sans',
  fontSize: '32px',
  fontWeight: 600,
  lineHeight: '40px',
  letterSpacing: '-0.4px'
} as const;

/** Local style used for the expand label in the left nav bar */
export const STYLES_SEMIBOLD_8PX_12PX = {
  fontFamily: 'Noto Sans',
  fontSize: '8px',
  fontWeight: 600,
  lineHeight: '12px',
  letterSpacing: '-0.06px'
} as const;

export const STYLES_SEMIBOLD_12PX_16PX = {
  fontFamily: 'Noto Sans',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '16px',
  letterSpacing: '-0.09px'
} as const;

export const STYLES_SEMIBOLD_16PX_24PX = {
  fontFamily: 'Noto Sans',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  letterSpacing: '-0.12px'
} as const;

export const STYLES_SEMIBOLD_10PX_14PX = {
  fontFamily: 'Noto Sans',
  fontSize: '10px',
  fontWeight: 600,
  lineHeight: '14px',
  letterSpacing: '-0.07px'
} as const;

export const STYLES_SEMIBOLD_14PX_20PX = {
  fontFamily: 'Noto Sans',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '-0.1px'
} as const;

export const STYLES_SEMIBOLD_24PX_32PX = {
  fontFamily: 'Noto Sans',
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '32px',
  letterSpacing: '-0.3px'
} as const;

/** 9664F0, p50, pu50 */
export const STYLES_PURPLE_PURPLE_50 = 'rgba(150, 100, 240, 1)' as const;

/** E7DDFC, p20, pu20 */
export const STYLES_PURPLE_PURPLE_20 = 'rgba(231, 221, 252, 1)' as const;

/** 8354D6, p60, pu60 */
export const STYLES_PURPLE_PURPLE_60 = 'rgba(131, 84, 214, 1)' as const;

/** 2E1954, p90, pu90 */
export const STYLES_PURPLE_PURPLE_90 = 'rgba(46, 25, 84, 1)' as const;

/** 462779, p80, pu80 */
export const STYLES_PURPLE_PURPLE_80 = 'rgba(70, 39, 121, 1)' as const;

/** 643AAA, p70, pu70 */
export const STYLES_PURPLE_PURPLE_70 = 'rgba(100, 58, 170, 1)' as const;

/** D2BDF9, p30, , pu30 */
export const STYLES_PURPLE_PURPLE_30 = 'rgba(210, 189, 249, 1)' as const;

/** 1C0D35, p100, pu100 */
export const STYLES_PURPLE_PURPLE_100 = 'rgba(28, 13, 53, 1)' as const;

/** BA99F6, p40, , pu40 */
export const STYLES_PURPLE_PURPLE_40 = 'rgba(186, 153, 246, 1)' as const;

/** F6F2FE, p10, pu10 */
export const STYLES_PURPLE_PURPLE_10 = 'rgba(246, 242, 254, 1)' as const;

/** 00004B */
export const STYLES_BRAND_COLORS_SYNGENTA_NAVY = 'rgba(0, 0, 75, 1)' as const;

/** FFFFFF */
export const STYLES_BRAND_COLORS_WHITE = 'rgba(255, 255, 255, 1)' as const;

/** 009933 */
export const STYLES_BRAND_COLORS_SYNGENTA_GREEN = 'rgba(0, 153, 51, 1)' as const;

/** 000000 */
export const STYLES_BRAND_COLORS_BLACK = 'rgba(0, 0, 0, 1)' as const;

/** BB485D, p60, pi60 */
export const STYLES_PINK_PINK_60 = 'rgba(187, 72, 93, 1)' as const;

/** FFF1F3, p10, pi10 */
export const STYLES_PINK_PINK_10 = 'rgba(255, 241, 243, 1)' as const;

/** FFD8DF, p20, pi20 */
export const STYLES_PINK_PINK_20 = 'rgba(255, 216, 223, 1)' as const;

/** 45161E, p90, pi90 */
export const STYLES_PINK_PINK_90 = 'rgba(69, 22, 30, 1)' as const;

/** 8D3545, p70, pi70 */
export const STYLES_PINK_PINK_70 = 'rgba(141, 53, 69, 1)' as const;

/** 2B0A10, p100, pi100 */
export const STYLES_PINK_PINK_100 = 'rgba(43, 10, 16, 1)' as const;

/** FFB2C1, p30, pi30 */
export const STYLES_PINK_PINK_30 = 'rgba(255, 178, 193, 1)' as const;

/** 65232F, p80, pi80 */
export const STYLES_PINK_PINK_80 = 'rgba(101, 35, 47, 1)' as const;

/** E85D78, p50, pi50 */
export const STYLES_PINK_PINK_50 = 'rgba(232, 93, 120, 1)' as const;

/** FF7D96, p40, pi40 */
export const STYLES_PINK_PINK_40 = 'rgba(255, 125, 150, 1)' as const;

/** F98989, r40 */
export const STYLES_RED_RED_40 = 'rgba(249, 137, 137, 1)' as const;

/** CF3537, r60 */
export const STYLES_RED_RED_60 = 'rgba(207, 53, 55, 1)' as const;

/** FFD9D9, r20 */
export const STYLES_RED_RED_20 = 'rgba(255, 217, 217, 1)' as const;

/** EB4B4B, r50 */
export const STYLES_RED_RED_50 = 'rgba(235, 75, 75, 1)' as const;

/** FFF1F1, r10 */
export const STYLES_RED_RED_10 = 'rgba(255, 241, 241, 1)' as const;

/** 9C2628, r70 */
export const STYLES_RED_RED_70 = 'rgba(156, 38, 40, 1)' as const;

/** 4C0E0F, r90 */
export const STYLES_RED_RED_90 = 'rgba(76, 14, 15, 1)' as const;

/** 70191A, r80 */
export const STYLES_RED_RED_80 = 'rgba(112, 25, 26, 1)' as const;

/** FFB3B3, r30 */
export const STYLES_RED_RED_30 = 'rgba(255, 179, 179, 1)' as const;

/** 300606, r100 */
export const STYLES_RED_RED_100 = 'rgba(48, 6, 6, 1)' as const;

/** 06431C, g80 */
export const STYLES_GREEN_GREEN_80 = 'rgba(6, 67, 28, 1)' as const;

/** 032D10, g90 */
export const STYLES_GREEN_GREEN_90 = 'rgba(3, 45, 16, 1)' as const;

/** 5EBB7F, g40 */
export const STYLES_GREEN_GREEN_40 = 'rgba(94, 187, 127, 1)' as const;

/** C3EAD1, g20 */
export const STYLES_GREEN_GREEN_20 = 'rgba(195, 234, 209, 1)' as const;

/** 90D6AA, g30 */
export const STYLES_GREEN_GREEN_30 = 'rgba(144, 214, 170, 1)' as const;

/** 011B07, g100 */
export const STYLES_GREEN_GREEN_100 = 'rgba(1, 27, 7, 1)' as const;

/** 14803C, g60 */
export const STYLES_GREEN_GREEN_60 = 'rgba(20, 128, 60, 1)' as const;

/** 0C612C, g70 */
export const STYLES_GREEN_GREEN_70 = 'rgba(12, 97, 44, 1)' as const;

/** DFFBE8, g10 */
export const STYLES_GREEN_GREEN_10 = 'rgba(223, 251, 232, 1)' as const;

/** 19A04B, g50 */
export const STYLES_GREEN_GREEN_50 = 'rgba(25, 160, 75, 1)' as const;

/** FFE4C2, o20 */
export const STYLES_ORANGE_ORANGE_20 = 'rgba(255, 228, 194, 1)' as const;

/** FFA24D, o40 */
export const STYLES_ORANGE_ORANGE_40 = 'rgba(255, 162, 77, 1)' as const;

/** FF7D0A, o50 */
export const STYLES_ORANGE_ORANGE_50 = 'rgba(255, 125, 10, 1)' as const;

/** 2D1500, o100 */
export const STYLES_ORANGE_ORANGE_100 = 'rgba(45, 21, 0, 1)' as const;

/** AD4D00, o70 */
export const STYLES_ORANGE_ORANGE_70 = 'rgba(173, 77, 0, 1)' as const;

/** 5A2600, o90 */
export const STYLES_ORANGE_ORANGE_90 = 'rgba(90, 38, 0, 1)' as const;

/** FFF7EB, o10 */
export const STYLES_ORANGE_ORANGE_10 = 'rgba(255, 247, 235, 1)' as const;

/** FFC388, o30 */
export const STYLES_ORANGE_ORANGE_30 = 'rgba(255, 195, 136, 1)' as const;

/** DB6300, o60 */
export const STYLES_ORANGE_ORANGE_60 = 'rgba(219, 99, 0, 1)' as const;

/** 823900, o80 */
export const STYLES_ORANGE_ORANGE_80 = 'rgba(130, 57, 0, 1)' as const;

/** 217C74, t60 */
export const STYLES_TEAL_TEAL_60 = 'rgba(33, 124, 116, 1)' as const;

/** 165C56, t70 */
export const STYLES_TEAL_TEAL_70 = 'rgba(22, 92, 86, 1)' as const;

/** 021917, t100 */
export const STYLES_TEAL_TEAL_100 = 'rgba(2, 25, 23, 1)' as const;

/** A9EFE8, t20 */
export const STYLES_TEAL_TEAL_20 = 'rgba(169, 239, 232, 1)' as const;

/** 0D413C, t80 */
export const STYLES_TEAL_TEAL_80 = 'rgba(13, 65, 60, 1)' as const;

/** E0F9F7, t10 */
export const STYLES_TEAL_TEAL_10 = 'rgba(224, 249, 247, 1)' as const;

/** 46BBB0, t40 */
export const STYLES_TEAL_TEAL_40 = 'rgba(70, 187, 176, 1)' as const;

/** 2B9C92, t50 */
export const STYLES_TEAL_TEAL_50 = 'rgba(43, 156, 146, 1)' as const;

/** 5FD2C8, t30 */
export const STYLES_TEAL_TEAL_30 = 'rgba(95, 210, 200, 1)' as const;

/** 062B27, t90 */
export const STYLES_TEAL_TEAL_90 = 'rgba(6, 43, 39, 1)' as const;

/** FFFFFF, White, n00 */
export const STYLES_NEUTRAL_NEUTRAL_00 = 'rgba(255, 255, 255, 1)' as const;

/** DFE2E7, n20 */
export const STYLES_NEUTRAL_NEUTRAL_20 = 'rgba(223, 226, 231, 1)' as const;

/** A3A9B9, n40 */
export const STYLES_NEUTRAL_NEUTRAL_40 = 'rgba(163, 169, 185, 1)' as const;

/** F3F4F6, n10 */
export const STYLES_NEUTRAL_NEUTRAL_10 = 'rgba(243, 244, 246, 1)' as const;

/** 696F88, n60 */
export const STYLES_NEUTRAL_NEUTRAL_60 = 'rgba(105, 111, 136, 1)' as const;

/** 868CA2, n50 */
export const STYLES_NEUTRAL_NEUTRAL_50 = 'rgba(134, 140, 162, 1)' as const;

/** 14151C, n100, black */
export const STYLES_NEUTRAL_NEUTRAL_100 = 'rgba(20, 21, 28, 1)' as const;

/** 232630, n90 */
export const STYLES_NEUTRAL_NEUTRAL_90 = 'rgba(35, 38, 48, 1)' as const;

/** C2C7D0, n30 */
export const STYLES_NEUTRAL_NEUTRAL_30 = 'rgba(194, 199, 208, 1)' as const;

/** 363948, n80 */
export const STYLES_NEUTRAL_NEUTRAL_80 = 'rgba(54, 57, 72, 1)' as const;

/** 4D5165, n70 */
export const STYLES_NEUTRAL_NEUTRAL_70 = 'rgba(77, 81, 101, 1)' as const;

/** C6E6FF, b20 */
export const STYLES_BLUE_BLUE_20 = 'rgba(198, 230, 255, 1)' as const;

/** 82CFFF, b30 */
export const STYLES_BLUE_BLUE_30 = 'rgba(130, 207, 255, 1)' as const;

/** 0092E4, b50 */
export const STYLES_BLUE_BLUE_50 = 'rgba(0, 146, 228, 1)' as const;

/** 005693, b70 */
export const STYLES_BLUE_BLUE_70 = 'rgba(0, 86, 147, 1)' as const;

/** 0071CD, b60 */
export const STYLES_BLUE_BLUE_60 = 'rgba(0, 113, 205, 1)' as const;

/** 003B69, b80 */
export const STYLES_BLUE_BLUE_80 = 'rgba(0, 59, 105, 1)' as const;

/** 30B3F1, b40 */
export const STYLES_BLUE_BLUE_40 = 'rgba(49, 180, 242, 1)' as const;

/** 00172D, b100 */
export const STYLES_BLUE_BLUE_100 = 'rgba(0, 23, 45, 1)' as const;

/** 002747, b90 */
export const STYLES_BLUE_BLUE_90 = 'rgba(0, 39, 71, 1)' as const;

/** EAF6FF, b10 */
export const STYLES_BLUE_BLUE_10 = 'rgba(234, 246, 255, 1)' as const;

/** 73DC78 */
export const STYLES_BRAND_COLORS_CROPWISE_GREEN = 'rgba(115, 220, 120, 1)' as const;

/** 2E2500, y100 */
export const STYLES_YELLOW_YELLOW_100 = 'rgba(46, 37, 0, 1)' as const;

/** AA7D00, y70 */
export const STYLES_YELLOW_YELLOW_70 = 'rgba(170, 125, 0, 1)' as const;

/** 573F00, y90 */
export const STYLES_YELLOW_YELLOW_90 = 'rgba(87, 63, 0, 1)' as const;

/** 805E00, y80 */
export const STYLES_YELLOW_YELLOW_80 = 'rgba(128, 94, 0, 1)' as const;

/** FFD86D, y40 */
export const STYLES_YELLOW_YELLOW_40 = 'rgba(255, 216, 109, 1)' as const;

/** FFF3C8, y20 */
export const STYLES_YELLOW_YELLOW_20 = 'rgba(255, 243, 200, 1)' as const;

/** FFCA11, y50 */
export const STYLES_YELLOW_YELLOW_50 = 'rgba(255, 202, 17, 1)' as const;

/** D6A000, y60 */
export const STYLES_YELLOW_YELLOW_60 = 'rgba(214, 160, 0, 1)' as const;

/** FFFAE5, y10 */
export const STYLES_YELLOW_YELLOW_10 = 'rgba(255, 250, 229, 1)' as const;

/** FFE8A0, y30 */
export const STYLES_YELLOW_YELLOW_30 = 'rgba(255, 232, 160, 1)' as const;

export const STYLES_REGULAR_56PX_64PX = {
  fontFamily: 'Noto Sans',
  fontSize: '56px',
  fontWeight: 400,
  lineHeight: '64px',
  letterSpacing: '-0.98px'
} as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_1 = '#eaf6ff' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_2 = '#c6e6ff' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_3 = '#82cfff' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_4 = '#31b4f2' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_5 = '#0092e4' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_6 = '#0071cd' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_7 = '#005693' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_8 = '#003b69' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_9 = '#002747' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_BLUE_10 = '#00172d' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_1 = '#dffbe8' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_2 = '#c3ead1' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_3 = '#90d6aa' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_4 = '#5ebb7f' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_5 = '#19a04b' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_6 = '#14803c' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_7 = '#0c612c' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_8 = '#06431c' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_9 = '#032d10' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_GREEN_10 = '#011b07' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_1 = '#ffdebf' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_2 = '#ffcc9d' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_3 = '#ffb979' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_4 = '#ffa755' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_5 = '#ff9b3e' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_6 = '#ee903a' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_7 = '#d48034' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_8 = '#ba712d' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_9 = '#3b240e' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_ORANGE_10 = '#3b240e' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_1 = '#fff1f3' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_2 = '#ffd8df' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_3 = '#ffb2c1' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_4 = '#ff7d96' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_5 = '#e85d78' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_6 = '#bb485d' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_7 = '#8d3545' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_8 = '#65232f' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_9 = '#45161e' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PINK_10 = '#2b0a10' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_1 = '#f6f2fe' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_2 = '#e7ddfc' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_3 = '#d2bdf9' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_4 = '#ba99f6' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_5 = '#9664f0' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_6 = '#8354d6' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_7 = '#643aaa' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_8 = '#462779' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_9 = '#2e1954' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_PURPLE_10 = '#1c0d35' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_1 = '#fff1f1' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_2 = '#ffd9d9' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_3 = '#ffb3b3' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_4 = '#f98989' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_5 = '#eb4b4b' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_6 = '#cf3537' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_7 = '#9c2628' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_8 = '#70191a' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_9 = '#4c0e0f' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_RED_10 = '#300606' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_1 = '#e0f9f7' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_2 = '#a9efe8' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_3 = '#5fd2c8' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_4 = '#46bbb0' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_5 = '#2b9c92' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_6 = '#217c74' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_7 = '#165c56' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_8 = '#0d413c' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_9 = '#062b27' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_TEAL_10 = '#021917' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_1 = '#fff3dd' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_2 = '#ffe4ae' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_3 = '#f0c355' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_4 = '#e99921' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_5 = '#744a0b' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_6 = '#9a6412' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_7 = '#c17e19' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_8 = '#523305' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_9 = '#372102' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_BASE_YELLOW_10 = '#221201' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT = '#fff3dd' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_SECONDARY = '#ffe4ae' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_TERTIARY = '#f0c355' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_QUATERNARY = '#e99921' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_LIGHT_SOLID = '#744a0b' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_HEADING = '#9a6412' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_LABEL = '#c17e19' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_DESCRIPTION = '#523305' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_DISABLED = '#372102' as const;

export const _1_COLORS_LIGHT_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_PLACEHOLDER = '#221201' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_1 = '#003b69' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_2 = '#005693' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_3 = '#0071cd' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_4 = '#0092e4' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_5 = '#31b4f2' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_6 = '#0092e4' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_7 = '#0071cd' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_8 = '#82cfff' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_9 = '#c6e6ff' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_BLUE_10 = '#eaf6ff' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_1 = '#011b07' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_2 = '#032d10' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_3 = '#06431c' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_4 = '#0c612c' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_5 = '#14803c' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_6 = '#19a04b' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_7 = '#5ebb7f' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_8 = '#90d6aa' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_9 = '#c3ead1' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_GREEN_10 = '#dffbe8' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_1 = '#3b240e' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_2 = '#3b240e' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_3 = '#ba712d' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_4 = '#d48034' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_5 = '#ee903a' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_6 = '#ff9b3e' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_7 = '#ffa755' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_8 = '#ffb979' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_9 = '#ffcc9d' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_ORANGE_10 = '#ffdebf' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_1 = '#2b0a10' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_2 = '#45161e' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_3 = '#65232f' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_4 = '#8d3545' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_5 = '#bb485d' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_6 = '#e85d78' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_7 = '#ff7d96' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_8 = '#ffb2c1' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_9 = '#ffd8df' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PINK_10 = '#fff1f3' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_1 = '#1c0d35' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_2 = '#2e1954' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_3 = '#462779' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_4 = '#643aaa' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_5 = '#8354d6' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_6 = '#9664f0' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_7 = '#ba99f6' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_8 = '#d2bdf9' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_9 = '#e7ddfc' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_PURPLE_10 = '#fff1f6' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_1 = '#300606' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_2 = '#4c0e0f' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_3 = '#70191a' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_4 = '#9c2628' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_5 = '#cf3537' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_6 = '#eb4b4b' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_7 = '#f98989' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_8 = '#ffb3b3' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_9 = '#ffd9d9' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_RED_10 = '#fff1f1' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_1 = '#021917' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_2 = '#062b27' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_3 = '#0d413c' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_4 = '#165c56' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_5 = '#217c74' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_6 = '#2b9c92' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_7 = '#46bbb0' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_8 = '#5fd2c8' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_9 = '#a9efe8' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_TEAL_10 = '#e0f9f7' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_1 = '#221201' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_2 = '#372102' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_3 = '#523305' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_4 = '#c17e19' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_5 = '#9a6412' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_6 = '#744a0b' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_7 = '#e99921' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_8 = '#f0c355' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_9 = '#ffe4ae' as const;

export const _1_COLORS_DARK_THEME_VALUE_BASE_YELLOW_10 = '#fff3dd' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT = '#221201' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_SECONDARY = '#372102' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_TERTIARY = '#523305' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_QUATERNARY = '#c17e19' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_LIGHT_SOLID = '#9a6412' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_HEADING = '#744a0b' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_LABEL = '#e99921' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_DESCRIPTION = '#f0c355' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_DISABLED = '#ffe4ae' as const;

export const _1_COLORS_DARK_THEME_VALUE_NEUTRAL_TEXT_COLOR_TEXT_PLACEHOLDER = '#fff3dd' as const;
